const automation = {
  id: 1,
  type: "automation",
  label: "Prepare for Automation",
};

export { automation };
